type AuthnetBlocksOpaqueData = {
	dataDescriptor: string;
	dataValue: string;
};

type AuthnetBlocksPaymentMethodData = {
	peachpay_authnet_data_descriptor: string;
	peachpay_authnet_data_value: string;
};

type AuthnetBlocksCheckoutFailData = {
	processingResponse?: {
		paymentDetails?: Record<string, string>;
		message?: string;
	} | null;
};

type AuthnetBlocksCheckoutFailEmitResponse = {
	responseTypes: {
		FAIL: string;
	};
	noticeContexts: {
		PAYMENTS: string;
	};
};

type AuthnetBlocksCheckoutFailResponse = {
	type: string;
	message: string;
	messageContext: string;
};

function createAuthnetBlocksPaymentMethodData(opaqueData: AuthnetBlocksOpaqueData): AuthnetBlocksPaymentMethodData {
	return {
		peachpay_authnet_data_descriptor: opaqueData.dataDescriptor,
		peachpay_authnet_data_value: opaqueData.dataValue,
	};
}

function getAuthnetBlocksCheckoutFailMessage(data: AuthnetBlocksCheckoutFailData, fallbackMessage: string): string {
	return data.processingResponse?.paymentDetails?.['message']
		?? data.processingResponse?.message
		?? fallbackMessage;
}

function createAuthnetBlocksCheckoutFailResponse(
	data: AuthnetBlocksCheckoutFailData,
	emitResponse: AuthnetBlocksCheckoutFailEmitResponse,
	fallbackMessage: string,
): AuthnetBlocksCheckoutFailResponse {
	return {
		type: emitResponse.responseTypes.FAIL,
		message: getAuthnetBlocksCheckoutFailMessage(data, fallbackMessage),
		messageContext: emitResponse.noticeContexts.PAYMENTS,
	};
}

export {
	createAuthnetBlocksCheckoutFailResponse,
	createAuthnetBlocksPaymentMethodData,
	getAuthnetBlocksCheckoutFailMessage,
	type AuthnetBlocksCheckoutFailData,
	type AuthnetBlocksCheckoutFailEmitResponse,
	type AuthnetBlocksCheckoutFailResponse,
	type AuthnetBlocksOpaqueData,
	type AuthnetBlocksPaymentMethodData,
};
